import { Actions } from './businesses.actions'
import { fromJS } from 'immutable'
import * as businessesTypes from './businesses.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    filters: [],
    filtered: 0,
    queryParams: {
      page: 1,
      page_size: 20,
    },
    pagination: {
      page: 1,
      page_size: 20,
    },
    total: 0,
  },
  createPayment: {
    isLoading: false,
    validationErrors: {},
  },
  update: {
    isLoading: false,
    detailsLoading: true,
    validationErrors: {},
    data: {},
    building: {},
    documents: {
      downloadDocumentLoading: false,
      deleteDocumentLoading: false,
      isLoading: false,
      data: {
        licenses: [],
        documents: [],
      },
    },
    payments: {
      isLoading: false,
      data: [],
    },
    createPayment: {
      isLoading: false,
    },
    updatePayment: {
      isLoading: false,
    },
    downloadPayment: {
      isLoading: false,
    },
  },
  create: {
    isLoading: false,
    validationErrors: {},
    data: {
      contactConnection: {},
    },
    building: null,
  },
})

export function businessesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case businessesTypes.UPLOAD_BUSINESS_IMAGE_REQUEST: {
      return state.setIn(['update', 'shouldReload'], false)
    }

    case businessesTypes.UPLOAD_BUSINESS_IMAGE_SUCCESS: {
      return state
        .setIn(['update', 'shouldReload'], true)
        .setIn(['update', 'data', 'images'], fromJS(action.payload))
    }

    case businessesTypes.UPLOAD_BUSINESS_IMAGE_FAILURE: {
      return state
    }

    case businessesTypes.DELETE_BUSINESS_IMAGE_REQUEST: {
      return state.setIn(['update', 'shouldReload'], false)
    }

    case businessesTypes.DELETE_BUSINESS_IMAGE_SUCCESS: {
      return state
        .setIn(['update', 'shouldReload'], true)
        .setIn(['update', 'data', 'images'], fromJS(action.payload))
    }

    case businessesTypes.DELETE_BUSINESS_IMAGE_FAILURE: {
      return state.setIn(['update', 'shouldReload'], false)
    }

    case businessesTypes.FETCH_BUSINESSES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case businessesTypes.FETCH_BUSINESSES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'filtered'], fromJS(action.filtered))
    }

    case businessesTypes.FETCH_BUSINESSES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case businessesTypes.FETCH_BUSINESS_DETAILS_REQUEST: {
      return state.setIn(['update', 'detailsLoading'], true)
    }

    case businessesTypes.FETCH_BUSINESS_DETAILS_SUCCESS: {
      let newState = state
        .setIn(['update', 'detailsLoading'], false)
        .setIn(['update', 'isLoading'], false)
        .setIn(['update', 'data'], fromJS(action.payload))
        .setIn(['update', 'building'], fromJS(action.building))

      return newState
    }

    case businessesTypes.UPDATE_BUSINESS_REQUEST: {
      return state.setIn(['update', 'isLoading'], true)
    }

    case businessesTypes.UPDATE_BUSINESS_SUCCESS: {
      return state
        .setIn(['update', 'isLoading'], false)
        .setIn(['update', 'data'], fromJS(action.payload))
    }

    case businessesTypes.UPDATE_BUSINESS_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case businessesTypes.CREATE_BUSINESS_REQUEST: {
      return state.setIn(['create', 'isLoading'], true)
    }

    case businessesTypes.CREATE_BUSINESS_SUCCESS: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case businessesTypes.CREATE_BUSINESS_FAILURE: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case businessesTypes.FETCH_BUSINESS_DETAILS_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case businessesTypes.FETCH_PROPERTY_BUILDING_REQUEST: {
      return state.setIn([action.target, 'building'], fromJS({}))
    }

    case businessesTypes.FETCH_PROPERTY_BUILDING_SUCCESS: {
      let newState = state.setIn(
        [action.target, 'building'],
        fromJS(action.payload),
      )
      const propertyConnection = state.getIn([
        action.target,
        'data',
        'propertyConnection',
      ]) as any

      if (!!propertyConnection) {
        newState = newState.setIn(
          [action.target, 'data', 'propertyConnection'],
          fromJS({
            ...propertyConnection.toJS(),
            area: 0,
            proportion: 0,
          }),
        )
      }

      return newState
    }

    case businessesTypes.FETCH_PROPERTY_BUILDING_FAILURE: {
      return state
    }

    case businessesTypes.FETCH_BUSINESS_DOCUMENTS_REQUEST: {
      return state.setIn(['update', 'documents', 'isLoading'], true)
    }

    case businessesTypes.FETCH_BUSINESS_DOCUMENTS_SUCCESS: {
      return state
        .setIn(['update', 'documents', 'isLoading'], false)
        .setIn(['update', 'documents', 'data'], fromJS(action.payload))
    }

    case businessesTypes.FETCH_BUSINESS_DOCUMENTS_FAILURE: {
      return state.setIn(['update', 'documents', 'isLoading'], false)
    }

    case businessesTypes.FETCH_BUSINESS_PAYMENTS_REQUEST: {
      return state.setIn(['update', 'payments', 'isLoading'], true)
    }

    case businessesTypes.FETCH_BUSINESS_PAYMENTS_SUCCESS: {
      return state
        .setIn(['update', 'payments', 'isLoading'], false)
        .setIn(['update', 'payments', 'data'], fromJS(action.payload))
    }

    case businessesTypes.FETCH_BUSINESS_PAYMENTS_FAILURE: {
      return state.setIn(['update', 'payments', 'isLoading'], false)
    }

    case businessesTypes.CREATE_BUSINESS_PAYMENT_REQUEST: {
      return state.setIn(['update', 'createPayment', 'isLoading'], true)
    }

    case businessesTypes.CREATE_BUSINESS_PAYMENT_SUCCESS: {
      const newPayments = (state.getIn(['update', 'payments', 'data']) as any)
        .toJS()
        .map((payment: any) => {
          if (payment.id == action.payload.id) {
            return action.payload
          }

          return payment
        })

      return state
        .setIn(['update', 'createPayment', 'isLoading'], false)
        .setIn(['update', 'payments', 'data'], fromJS(newPayments))
    }

    case businessesTypes.CREATE_BUSINESS_PAYMENT_FAILURE: {
      return state.setIn(['update', 'createPayment', 'isLoading'], false)
    }

    case businessesTypes.UPDATE_BUSINESS_PAYMENT_REQUEST: {
      return state.setIn(['update', 'updatePayment', 'isLoading'], true)
    }

    case businessesTypes.UPDATE_BUSINESS_PAYMENT_SUCCESS: {
      const newPayments = (state.getIn(['update', 'payments', 'data']) as any)
        .toJS()
        .map((payment: any) => {
          if (payment.id == action.payload.id) {
            return action.payload
          }

          return payment
        })

      return state
        .setIn(['update', 'updatePayment', 'isLoading'], false)
        .setIn(['update', 'payments', 'data'], fromJS(newPayments))
    }

    case businessesTypes.UPDATE_BUSINESS_PAYMENT_FAILURE: {
      return state.setIn(['update', 'updatePayment', 'isLoading'], false)
    }

    case businessesTypes.DELETE_BUSINESS_PAYMENT_REQUEST: {
      return state
    }

    case businessesTypes.DELETE_BUSINESS_PAYMENT_SUCCESS: {
      const newPayments = (state.getIn(['update', 'payments', 'data']) as any)
        .toJS()
        .map((payment: any) => {
          if (payment.id == action.payload.id) {
            return action.payload
          }

          return payment
        })

      return state.setIn(['update', 'payments', 'data'], fromJS(newPayments))
    }

    case businessesTypes.DELETE_BUSINESS_PAYMENT_FAILURE: {
      return state
    }

    case businessesTypes.DOWNLOAD_BUSINESS_PAYMENT_REQUEST: {
      return state.setIn(['update', 'downloadPayment', 'isLoading'], true)
    }

    case businessesTypes.DOWNLOAD_BUSINESS_PAYMENT_SUCCESS: {
      return state.setIn(['update', 'downloadPayment', 'isLoading'], false)
    }

    case businessesTypes.DOWNLOAD_BUSINESS_PAYMENT_FAILURE: {
      return state.setIn(['update', 'downloadPayment', 'isLoading'], false)
    }

    case businessesTypes.GENERATE_BUSINESS_DOCUMENT_REQUEST: {
      return state.setIn(
        ['update', 'documents', 'generateDocumentLoading'],
        true,
      )
    }

    case businessesTypes.GENERATE_BUSINESS_DOCUMENT_SUCCESS: {
      const newDocument = action.payload.data
      const newDocuments = (
        state.getIn(['update', 'documents', 'data', 'licenses']) as any
      )
        .toJS()
        .map((document: any) => {
          if (document.dataCycle.id === newDocument.dataCycle.id) {
            return newDocument
          }

          return document
        })

      return state
        .setIn(['update', 'documents', 'generateDocumentLoading'], false)
        .setIn(
          ['update', 'documents', 'data', 'licenses'],
          fromJS(newDocuments),
        )
    }

    case businessesTypes.DELETE_BUSINESS_DOCUMENT_REQUEST: {
      return state.setIn(['update', 'documents', 'deleteDocumentLoading'], true)
    }

    case businessesTypes.DELETE_BUSINESS_DOCUMENT_SUCCESS: {
      return state.setIn(
        ['update', 'documents', 'deleteDocumentLoading'],
        false,
      )
    }

    case businessesTypes.DELETE_BUSINESS_DOCUMENT_FAILURE: {
      return state.setIn(
        ['update', 'documents', 'deleteDocumentLoading'],
        false,
      )
    }

    case businessesTypes.UPLOAD_DOCUMENT_REQUEST: {
      return state
    }

    case businessesTypes.UPLOAD_DOCUMENT_SUCCESS: {
      return state.setIn(
        ['update', 'documents', 'data', 'documents'],
        fromJS(action.payload),
      )
    }

    case businessesTypes.UPLOAD_DOCUMENT_FAILURE: {
      return state
    }

    case businessesTypes.DELETE_DOCUMENT_REQUEST: {
      return state.setIn(['update', 'documents', 'deleteDocumentLoading'], true)
    }

    case businessesTypes.DELETE_DOCUMENT_SUCCESS: {
      return state
        .setIn(
          ['update', 'documents', 'data', 'documents'],
          fromJS(action.payload),
        )
        .setIn(['update', 'documents', 'deleteDocumentLoading'], true)
    }

    case businessesTypes.DELETE_DOCUMENT_FAILURE: {
      return state.setIn(['update', 'documents', 'deleteDocumentLoading'], true)
    }

    case businessesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case businessesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
